module.exports = __webpack_public_path__ + "media/media/icons/question-c531c4f32654af01f7ca02db7ec6ff8c.png";